import { getTimezoneData } from "@src/services";
import { useEffect, useState } from "react";

/**
 * Fetches the IANA timezone for a given lat/lon pair.
 * Re-fetches automatically when the coordinates change (i.e. when the user
 * enters a new ZIP and the address resolves).
 */
export const useTimezone = (
  lat: number | undefined,
  lon: number | undefined,
  userUuid: string | undefined,
) => {
  const [timezone, setTimezone] = useState<any>(null);

  useEffect(() => {
    // Use null-check so coordinates of 0 are treated as valid.
    if (lat == null || lon == null) {
      setTimezone(null);
      return;
    }

    let cancelled = false;

    // Reset stale timezone before the request resolves.
    setTimezone(null);

    const loadTimezone = async () => {
      try {
        const timezoneResponse = await getTimezoneData(lat, lon, userUuid || "unknown");
        if (cancelled) return;
        if (timezoneResponse.success && timezoneResponse.data) {
          setTimezone(timezoneResponse.data);
        } else {
          setTimezone(null);
        }
      } catch (error) {
        if (cancelled) return;
        setTimezone(null);
      }
    };

    loadTimezone();

    return () => {
      cancelled = true;
    };
  }, [lat, lon, userUuid]);

  return timezone;
};
